import { createBrowserRouter, Route, Routes } from "react-router-dom";

import { PORTAL_USER_TYPE } from "@/app/models";
import { usePortalUserStore } from "@/app/stores";
import { getBillingRoute } from "@/features/billing/router";
import {
  AdminCoachingRouter,
  getCoachingRoute,
} from "@/features/coaching/router";
import {
  EMBEDDABLES_ROUTE,
  EmbeddablesRouter,
} from "@/features/embeddables/router";
import { getFormsRoute } from "@/features/forms/router";
import { getFunnelRoute } from "@/features/funnel/router";
import { GuestRouter } from "@/features/guest/router";
import { getIntakeFormRoute } from "@/features/intake-form/router";
import { getLongevityRoute } from "@/features/longevity-onboarding/router";
import { getMyMedsRoute } from "@/features/my-meds/router";
import { onboardingRoute } from "@/features/onboarding/router";
import { getShopRoute } from "@/features/products/router";
import { getQuestionnaireRoute } from "@/features/questionnaire-onboarding/router";
import { LogoLoader } from "@/shared/components";
import { useAuthStore } from "@/shared/stores";
import { BaseRouter, ErrorBoundary } from "./components";
import { CoachingUserRouter } from "./components/coaching-user-router";
import { PatientUserRouter } from "./components/patient-user-router";
import { ADMIN_ROUTES } from "./constants";
import { useSetPortalUser } from "./hooks";

const Root = () => {
  const { isLoading } = useSetPortalUser();
  const isLoggedOut = useAuthStore((state) => !state.token);
  const userType = usePortalUserStore((state) => state.portalUser?.type);

  if (isLoading) {
    return <LogoLoader fullscreen variant="secondary" />;
  }

  return (
    <Routes>
      <Route path="/" element={<BaseRouter />} />

      <Route
        path={`${EMBEDDABLES_ROUTE.BASE}/*`}
        element={<EmbeddablesRouter />}
      />

      <Route
        path={`${ADMIN_ROUTES.COACHING.BASE}/*`}
        element={<AdminCoachingRouter />}
      />

      {isLoggedOut && <Route path="*" element={<GuestRouter />} />}

      {userType === PORTAL_USER_TYPE.PATIENT && (
        <Route path="*" element={<PatientUserRouter />} />
      )}

      {userType === PORTAL_USER_TYPE.COACHING && (
        <Route path="*" element={<CoachingUserRouter />} />
      )}

      <Route path="*" element={<BaseRouter />} />
    </Routes>
  );
};

/**
 * Migration Guide: For details on migrating to RouterProvider,
 * please refer to the documentation at for the new routers:
 * [Migration Documentation](https://reactrouter.com/6.28.0/upgrading/v6-data)
 */
export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: [
      onboardingRoute(),
      getLongevityRoute(),
      getFunnelRoute(),
      getQuestionnaireRoute(),
      getIntakeFormRoute(),
      getMyMedsRoute(),
      getBillingRoute(),
      getFormsRoute(),
      getShopRoute(),
      getCoachingRoute(),
      { path: "*", element: <Root /> },
    ],
  },
]);
